import config from '../config';
import axios from 'axios';

export const trendingService = {
    getTrendingList,
};

//-- getTrendingList
function getTrendingList(apiName, tagsData) {
    let token = JSON.parse(sessionStorage.getItem('token'));    
    return axios({
        method: 'POST',
        url: `${config.apiUrl+apiName}`,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        data: tagsData
    }).then(handleResponse);
}


function handleResponse(response) {
    if (response.status == 200||response.status == 201) {
        return response;
    } else {
        const error = response;
        return Promise.reject(error);
    }
}